import React from 'react'
import { Button, Title } from '../../style/StyleComponent'
import '../../App.css'
import './ustozlar.style'
import { BizningKurslar } from '../bizningKurslarimiz/BizningKurslarimizData'
import { UstozlarSection } from './ustozlar.style'
import Success from '../success/Success'
import Motivation from '../motivation/Motivation'
import { useNavigate } from 'react-router-dom'

const Teachers = () => {
  const navigate = useNavigate(); // 2. Hook-ni chaqiramiz

    const ustozlarCardClick = (id) => {
        // Kurs sahifasiga yo'naltirish (masalan: /course/1)
        navigate(`/ustoz/${id}`);
    };
  return (
    <div>

    <div className='max-width' >
      <Title>
        Kuchli bilimlarga ega ustozlar
      </Title>

      <UstozlarSection>
      <div className="ustozlar-card-cont">
        {BizningKurslar.map((item, index) => (
          <div key={index}>
            <img src={item.imgUstoz} alt="salom" />

            <p className='ustoz-name'>
              {item.ustoz}
            </p>

            <p>
              {item.kategoriya}
            </p>
            <Button onClick={() => ustozlarCardClick(item.id)}>
              Batafsil ma`lumot
            </Button>
          </div>
        ))}
      </div>
      </UstozlarSection>
      <Success />

    </div>
      <Motivation/>
        </div>
  )
}

export default Teachers
